import React from 'react';
import {
    Alert,
    Button,
    Div,
    NativeSelect,
    SplitCol,
    SplitLayout,
} from '@vkontakte/vkui';
import {
    ACCESS_DENIED_MESSAGE,
    AdaptivityContext,
    getSalePointsTypes,
    isTradeDesigner,
    userIsTradeChild,
} from "../assets/constants";
import {Icon20AddCircleFillGreen} from "@vkontakte/icons";
import BaseList from "../components/BaseList";
import SalePointListRow from "../components/SalePointListRow";
import SalePointsApi from "../api/references/salePoints";

class SalePointsList extends BaseList {
    constructor(props) {
        super(props);
        this.types = getSalePointsTypes();
        this.salePointsGalleryTimestamp = new Date().getTime();
        if (this.state.closedFilter === undefined) {
            this.state.closedFilter = null;
        }
    }

    getAdditionalStateToSave() {
        return {
            closedFilter: this.state.closedFilter
        };
    }

    setClosedFilter = (closedFilter) => {
        this.setState({closedFilter, loading: true, page: 1, items: []}, () => {
            this.getItems(this.state.mainSearch, false, 1);
        });
    }

    getObjectLink = (item) => {
        if (!item || item.id == null || item.id <= 0) {
            return null;
        }
        return {type: 'salePoint', id: item.id};
    }

    renderToolbar = () => {
        const isDesigner = isTradeDesigner(this.props.current_user);
        const closedSelectValue = (this.state.closedFilter === null || this.state.closedFilter === undefined)
            ? ''
            : String(this.state.closedFilter);
        const headerClass = AdaptivityContext.isMobile
            ? 'mobile-table-storage-header'
            : 'desktop-table-storage-header';
        const onClosedChange = (e) => {
            const v = e.target.value;
            const closedFilter = v === '' ? null : Number(v);
            this.setClosedFilter(closedFilter);
        };
        const selectEl = (
            <NativeSelect
                style={AdaptivityContext.isMobile
                    ? {width: '100%', maxWidth: '100%', boxSizing: 'border-box'}
                    : {minWidth: 130, maxWidth: 'min(200px, 42vw)', flex: '0 0 auto'}}
                value={closedSelectValue}
                onChange={onClosedChange}
            >
                <option value="">Все</option>
                <option value="0">Открытые</option>
                <option value="1">Закрытые</option>
            </NativeSelect>
        );
        const addBtn = !isDesigner ? (
            <Button mode="outline" disabled={this.state.isOffline}
                    onClick={() => this.createItem()}><Icon20AddCircleFillGreen/></Button>
        ) : null;
        const countSpan = (
            <span className="all-docs" id="cnt_items">Всего элементов: {this.state.cnt_items}</span>
        );

        const mobileToolbarWrapStyle = {
            marginTop: -6,
            marginBottom: 10,
            paddingBottom: 12,
            boxSizing: 'border-box',
        };
        const mobileToolbarRowPad = {
            paddingTop: 4,
            paddingBottom: 4,
            paddingLeft: 8,
            paddingRight: 8,
            boxSizing: 'border-box',
        };

        if (AdaptivityContext.isMobile) {
            return (
                <div className={headerClass} style={mobileToolbarWrapStyle}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: '100%',
                        minWidth: 0,
                        ...mobileToolbarRowPad,
                    }}>
                        <div style={{flexShrink: 0}}>{addBtn}</div>
                        <div style={{
                            flex: '1 1 auto',
                            minWidth: 0,
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            flexWrap: 'nowrap',
                            gap: 6,
                        }}>
                            <div style={{
                                flex: '0 1 auto',
                                maxWidth: 'min(168px, 46vw)',
                                minWidth: 0,
                            }}>
                                {selectEl}
                            </div>
                            <span
                                className="all-docs"
                                id="cnt_items"
                                style={{
                                    fontSize: 12,
                                    lineHeight: '16px',
                                    whiteSpace: 'nowrap',
                                    flexShrink: 0,
                                }}
                            >
                                Всего элементов: {this.state.cnt_items}
                            </span>
                        </div>
                    </div>
                </div>
            );
        }

        return <div className={headerClass}>
            <SplitLayout>
                <SplitCol style={{justifyContent: "flex-start"}}>
                    <Div>{addBtn}</Div>
                </SplitCol>
                <SplitCol>
                    <Div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        gap: 10,
                        justifyContent: 'flex-end'
                    }}>
                        {selectEl}
                        {countSpan}
                    </Div>
                </SplitCol>
            </SplitLayout>
        </div>;
    }

    getImagesUrl = () => {
        return (this.props.base_url || this.state.base_url).replace("frontend/", '');
    }

    getItems = (mainSearch = '', append, page) => {
        clearInterval(this.searchInterval);

        this.setState({loading: true});
        append = append == undefined ? false : append;
        if (page == undefined) {
            page = this.state.page;
        }
        if (mainSearch == undefined) {
            mainSearch = this.state.mainSearch;
        }

        const listBody = {
            search: mainSearch,
            page,
            epp: AdaptivityContext.isMobile ? 10 : 20
        };
        if (this.state.closedFilter !== null && this.state.closedFilter !== undefined) {
            listBody.closed = this.state.closedFilter;
        }

        SalePointsApi.getListMalls(listBody).then((response) => {
            this.setState({loading: false});
            let old = this.state.items;
            if (!append) {
                old = response.data.results;
            } else {
                response.data.results.map((el) => {
                    old.push(el);
                });
            }

            this.setState({items: old});
            this.setState({cnt_items: response.data.iTotalRecords});
            this.setState({totalPages: response.data.iTotalPages});

            if (response.data.iTotalPages * 1 > 0) {
                setTimeout(() => {
                    this.checkScroll();
                }, 500);
            }
        });
    }

    createItem = () => {
        if (isTradeDesigner(this.props.current_user)) {
            window.postMessage({
                type: 'error',
                text: ACCESS_DENIED_MESSAGE,
                timeout: 3000
            });
            return;
        }
        window.postMessage({
            type: 'setCurrentSalePointRef',
            value: {
                id: -1,
                info: '',
                comment: '',
                images: [],
                isMall: 0
            }
        });
    }

    /**
     * Backend may return the entity at the root or nested (result / data / item).
     */
    normalizeGetOnePayload(data) {
        if (!data || typeof data !== 'object') {
            return null;
        }
        if (data.id != null && data.id !== '') {
            return data;
        }
        if (data.result && data.result.id != null) {
            return data.result;
        }
        if (data.data && data.data.id != null) {
            return data.data;
        }
        if (data.item && data.item.id != null) {
            return data.item;
        }
        return null;
    }

    openItem = (point) => {
        this.setLastOpenedItem(point.id);
        if (point.id == null || point.id < 0) {
            window.postMessage({
                type: 'setCurrentSalePointRef',
                value: point
            });
            return;
        }
        SalePointsApi.getOne(point.id)
            .then((response) => {
                const payload = this.normalizeGetOnePayload(response.data);
                if (payload) {
                    window.postMessage({
                        type: 'setCurrentSalePointRef',
                        value: payload
                    });
                    return;
                }
                window.postMessage({
                    type: 'error',
                    text: 'Не удалось загрузить данные торговой точки',
                    timeout: 5000
                });
            })
            .catch((err) => {
                let text = 'Ошибка при загрузке торговой точки';
                const d = err && err.response && err.response.data;
                if (err && err.response && err.response.status === 403) {
                    text = ACCESS_DENIED_MESSAGE;
                } else if (typeof d === 'string' && d.trim()) {
                    text = d;
                } else if (d && typeof d.message === 'string') {
                    text = d.message;
                } else if (err && err.message) {
                    text = err.message;
                }
                window.postMessage({
                    type: 'error',
                    text,
                    timeout: 5000
                });
            });
    }

    deleteItem = (point, index) => {
        if (isTradeDesigner(this.props.current_user)) {
            window.postMessage({
                type: 'error',
                text: ACCESS_DENIED_MESSAGE,
                timeout: 3000
            });
            return;
        }
        const alert = <Alert
            onClose={() => this.setState({currentPopout: null})}
            actionsAlign="left"
            actionsLayout="horizontal"
            actions={[
                {
                    title: 'Да',
                    action: () => {
                        SalePointsApi.deleteSalePoint(point.id).then(() => {
                            const {items} = this.state;
                            items.splice(index, 1);
                            this.setState({items, currentPopout: null});
                        });
                    },
                },
                {
                    title: 'Нет',
                    action: () => this.setState({currentPopout: null}),
                },
            ]}
            header="Удаление торговой точки"
            text="Торговая точка будет удалена. Продолжить?"
        />;

        this.setState({currentPopout: alert});
    }

    renderRow = (point, index) => {
        const isTradeChild = userIsTradeChild(this.props.current_user, point.user_id);
        const backgroundColor = point.closed == 1 ? 'rgba(245, 210, 214, 0.65)' : 'inherit';

        return (
            <SalePointListRow
                point={point}
                index={index}
                rowStyle={this.getRowStyle(point, {backgroundColor})}
                types={this.types}
                images_url={this.getImagesUrl()}
                galleryTimestamp={this.salePointsGalleryTimestamp}
                isTradeChild={isTradeChild}
                onOpen={this.openItem}
                onDelete={this.deleteItem}
            />
        );
    }
}

export default SalePointsList;
